module.exports = __webpack_public_path__ + "static/Alto-Logo-1170040f74ddd7c24a9bc0d29e7c9bf0.svg";